var data = {
  en: {
    translation: {
      signables: {
        actions: {
          create_signature: 'Create Signature'
        },
        headings: {
          setup_signature: 'Set Up Your Signature'
        },
        labels: {
          click_to_add_signature: 'Click to add your signature',
          initials: 'Initials',
          your_full_name: 'Your full name'
        },
        messages: {
          create_your_signature: 'Please enter your full name below to create your online ' + 'signature. The information you enter will be the electronic representation ' + 'of your signature and initials.'
        }
      }
    }
  },
  es: {
    translation: {
      signables: {
        actions: {
          create_signature: 'Establecer firma'
        },
        headings: {
          setup_signature: 'Establecer su firma'
        },
        labels: {
          click_to_add_signature: 'Haga clic para añadir su firma',
          initials: 'Iniciales',
          your_full_name: 'Su nombre completo'
        },
        messages: {
          create_your_signature: 'Favor de entrar su nombre completo abajo para establecer su ' + 'firma por internet. La información que usted entre será la representación ' + 'electrónica de su firma y iniciales.'
        }
      }
    }
  }
};
export default data;